import { render, staticRenderFns } from "./OutputAssessmentOfTheRiskOfBias.vue?vue&type=template&id=2af85217&scoped=true"
import script from "./OutputAssessmentOfTheRiskOfBias.vue?vue&type=script&lang=js"
export * from "./OutputAssessmentOfTheRiskOfBias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af85217",
  null
  
)

export default component.exports